"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Legacy = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var Legacy = function () {
    return react_1.default.createElement(LogoArea, null);
};
exports.Legacy = Legacy;
var LogoArea = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  height: 60px;\n  width: 100%;\n  padding: 20px 24px;\n  box-sizing: border-box;\n  background-color: ", ";\n"], ["\n  height: 60px;\n  width: 100%;\n  padding: 20px 24px;\n  box-sizing: border-box;\n  background-color: ", ";\n"])), function (props) { return props.theme.colors.bg; });
var templateObject_1;
